import { ACTION_STATUS } from "../actionbar-detail.constant";
import { ButtonBase } from "./button.base";

export class CreditNoteButtonModel extends ButtonBase {
    label: string = 'Credit Note';
    action: string = ACTION_STATUS.creditNote;
    matIconName: string = 'description';
    colorClass: string = 'color-info-500';
}